export const host = process.env.VUE_APP_API_HOST
export const hostForImage = process.env.VUE_APP_HOST_FOR_IMAGE
export const imageOldSite = process.env.VUE_APP_IMAGE_OLD_SITE